var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 28,
    viewBox: "0 0 16 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24395 1C7.24395 6.46818 7.24395 11.9364 7.24395 17.4045C7.24395 18.4078 7.62394 25.2419 6.8856 24.6512C5.62799 23.6451 4.49092 21.8982 3.30208 20.7093C-0.973886 16.4334 3.96891 25.0368 5.09384 26.443C7.21011 29.0883 13.5512 16.7671 14.411 15.3341",
    stroke: "#2F2F37",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/down.7ecbb63be8e2bce7bfcc725ee5963f31.svg";
export { ForwardRef as ReactComponent };